import React from 'react';

type Props = {
    violet?: boolean,
    href: string,
    text: string,
};

const LinkTo = ({ violet, href, text }: Props) => (
    <a data-scroll href={href} className={`button ${violet ? 'button_violet' : ''}`}>
        <span className={`text-button ${violet ? 'text-white' : ''}`}>
            {text}
        </span>
    </a>
);

export default LinkTo;